import { Stack, Text } from '@mantine/core'
import React from 'react'
import { useTheme } from '../../../components/ThemeProvider'

interface LimitHighConsumptionCaseProps {
  number: number
  item: any
}

export default function LimitHighConsumptionCase({ number, item }: LimitHighConsumptionCaseProps) {
  const theme = useTheme()

  const headerFields = [
    { label: '案号', value: item?.caseCode },
    { label: '执行法院', value: item?.courtName },
    { label: '发布时间', value: item?.casePublishTime },
    { label: '限制内容', value: item?.obligation },
  ].filter((field) => field.value)

  const extraFields = [
    { label: '所属地域', value: item?.areaName },
    { label: '执行依据文号', value: item?.executionBasisDocNo },
    { label: '执行依据单位', value: item?.executionBasisUnit },
  ].filter((field) => field.value)

  return (
    <div
      className="rounded-lg border px-4 py-4"
      style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
    >
      <Stack gap="sm">
        <Text size="xs" c="dimmed">
          案件 {number}
        </Text>
        {headerFields.length > 0 && (
          <div className="grid gap-3 md:grid-cols-2">
            {headerFields.map((field) => (
              <FieldRow key={field.label} label={field.label} value={field.value} />
            ))}
          </div>
        )}
        {extraFields.length > 0 && (
          <div className="grid gap-3 md:grid-cols-2">
            {extraFields.map((field) => (
              <FieldRow key={field.label} label={field.label} value={field.value} />
            ))}
          </div>
        )}
      </Stack>
    </div>
  )
}

interface FieldRowProps {
  label: string
  value?: string
}

function FieldRow({ label, value }: FieldRowProps) {
  return (
    <div className="flex flex-col gap-1">
      <Text size="xs" c="dimmed">
        {label}
      </Text>
      <Text size="sm" className="text-gray-700" fw={500}>
        {value || '—'}
      </Text>
    </div>
  )
}
